import Operation from "../index.js";

export default {
    //学生端我的考试列表
    myTestPaperList(params, fn) {
        Operation.Http.post(`/test/myTestPaperList`, params, fn)
    },
    // 查看考试信息
    findTest(id,fun){
        Operation.Http.post(`/test/findTest?testId=${id}`, null, fun)
    },
}




// WEBPACK FOOTER //
// ./src/request/api/test.js